import * as React from "react";
const SvgLogo = (props) => (
  <svg
    width={17}
    height={32}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <g clipPath="url(#Logo_svg__a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m.295 21.55.608-.27c.023-.01 1.011-.454 2.482-1.29.278.641.584 1.255.917 1.837-.827.465-1.504.81-1.955 1.03v5.976a25.005 25.005 0 0 0 4.676-3.315c.485.526.98 1.016 1.477 1.468.497-.452.992-.942 1.477-1.468a25.005 25.005 0 0 0 4.676 3.315v-5.976a37.83 37.83 0 0 1-1.955-1.03c.333-.582.64-1.196.917-1.836a32.38 32.38 0 0 0 2.482 1.289l.608.27V32l-1.415-.577c-.251-.103-3.535-1.48-6.79-4.437-3.255 2.958-6.538 4.334-6.79 4.437L.295 32V21.55Z"
        fill="url(#Logo_svg__b)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.385 19.99a17.982 17.982 0 0 1-1.291-4.48C1.18 9.487 3.51 3.7 8.5 0c4.988 3.7 7.319 9.487 6.406 15.51a17.984 17.984 0 0 1-1.291 4.48c-.278.641-.584 1.255-.917 1.837a20.48 20.48 0 0 1-2.721 3.69c-.485.527-.98 1.017-1.477 1.468a23.31 23.31 0 0 1-1.477-1.467 20.485 20.485 0 0 1-2.721-3.691 18.544 18.544 0 0 1-.917-1.836ZM8.5 24.05c.877-.96 1.709-2.051 2.417-3.282.336-.585.643-1.201.914-1.849.477-1.139.843-2.374 1.046-3.713.938-6.188-1.703-10.139-4.377-12.48-2.674 2.341-5.315 6.292-4.377 12.48a15.636 15.636 0 0 0 1.046 3.713c.27.648.578 1.264.914 1.849A18.664 18.664 0 0 0 8.5 24.05Z"
        fill="url(#Logo_svg__c)"
      />
      <path
        d="M6.707 16.252c0 2.286 1.793 4.14 1.793 4.14s1.792-1.854 1.792-4.14c0-2.286-1.792-4.14-1.792-4.14s-1.793 1.854-1.793 4.14Z"
        fill="url(#Logo_svg__d)"
      />
    </g>
    <defs>
      <linearGradient
        id="Logo_svg__b"
        x1={10.278}
        y1={20.178}
        x2={8.581}
        y2={30.548}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#543AFE" />
        <stop offset={1} stopColor="#6F23DE" />
      </linearGradient>
      <linearGradient
        id="Logo_svg__c"
        x1={9.93}
        y1={0.42}
        x2={0.883}
        y2={20.211}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#543AFE" />
        <stop offset={1} stopColor="#6F23DE" />
      </linearGradient>
      <linearGradient
        id="Logo_svg__d"
        x1={8.888}
        y1={12.242}
        x2={5.896}
        y2={18.037}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#543AFE" />
        <stop offset={1} stopColor="#6F23DE" />
      </linearGradient>
      <clipPath id="Logo_svg__a">
        <path fill="#fff" transform="translate(.295)" d="M0 0h16.41v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogo;
